import { useParams, useNavigate } from "react-router-dom";

import ErrorBoundary from "@/ui/organisms/ErrorBoundary";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

import {
    ViewDatabaseGuard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
    ViewChartsOfAccountsAuditLog,
} from "@/ui/compositionRootUI";

import { routerPaths } from "@/ui/router/routerPaths";
import GridLoader from "@/ui/molecules/GridLoader";

const VIEW_CHART_OF_ACCOUNTS_MAPPINGS_ACTION_BAR_HEIGHT = 100;

const PageChartsOfAccountsAuditLog = () => {
    const navigate = useNavigate();

    const { coaId } = useParams<{ coaId: string }>();

    const onClickBackButton = ({ coaId }: { coaId: number }) => {
        navigate(routerPaths.chartsOfAccounts.view(String(coaId)));
    };

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard
                    loader={
                        <GridLoader
                            sx={{
                                paddingTop: `${VIEW_CHART_OF_ACCOUNTS_MAPPINGS_ACTION_BAR_HEIGHT}px`,
                            }}
                        />
                    }
                >
                    <LayoutFillParentCentered>
                        <ViewChartsOfAccountsAuditLog
                            coaId={Number(coaId)}
                            onClickBackButton={onClickBackButton}
                        />
                    </LayoutFillParentCentered>
                </ViewDatabaseGuard>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageChartsOfAccountsAuditLog;
